import './TreeMapTooltip.css';
export var headerText = '_prynea0-2-0-1';
export var valueChip = '_prynea1-2-0-1';